module.exports = __webpack_public_path__ + "img/sign-in-logo.192dfd19.png";